import { Controller } from "stimulus"
import { getRequest, pathname } from "@react/helpers/fetch"

export default class extends Controller {
  static targets = ["id", "quantity", "container", "product", "reference", "unit", "price", "discount", "billingCategory", "vat"]

  select() {
    const product = this.productTarget.value
    if (!product) return (console.info("no product"))

    const path     = this.data.get("path")
    const format   = "json"
    const supplier = document.querySelector("input[name*='[supplier_id]']")
    const client   = document.querySelector("input[name*='[client_id]']")
    const params   = { product }
    if (supplier && supplier.value) params.supplier = supplier.value
    if (client   && client.value)   params.client   = client.value
    const url      = pathname({ path, format, params })

    getRequest(url).then(response => {
      this.product = response.product
      this._fillData()
      this._replaceInput()
      this.priceTarget.dispatchEvent(new Event("keyup"))
      this.quantityTarget.focus()
    })
  }

  _fillData() {
    const quillBox       = this.element.querySelector(".ql-editor")
    quillBox.innerHTML   = this.product.html
    const productVatRate = this.product.vat_rate
    const siteVatRate    = this._readDataElement()?.site?.vat_rate

    function getVatTarget(siteVatRate, productVatRate) {
      if (!siteVatRate) {
          return productVatRate?.id
      } else if (productVatRate?.percentage && productVatRate?.percentage < siteVatRate?.percentage) {
          return siteVatRate?.id
      } else {
          return siteVatRate?.id
      }
    }

    this.idTarget.value        = this.product.id
    this.referenceTarget.value = this.product.ref_product_brand
    this.unitTarget.value      = this.product.unit
    this.vatTarget.value       = this.vatTarget.value = getVatTarget(siteVatRate, productVatRate)

    if (this.hasBillingCategoryTarget && this.product.billing_category) {
      const event = new CustomEvent('combobox:update', { detail: this.product.billing_category })
      this.billingCategoryTarget.dispatchEvent(event)
    }
    if (this.data.get("purchase") == "true") {
      this.priceTarget.value = this.product.purchase_price
    } else {
      this.priceTarget.value = this.product.sale_price
    }

    // discount is only sent for invoice lines; blank it otherwise so the field
    // matches a freshly rendered line.
    if (this.hasDiscountTarget && this.product.discount != null) {
      this.discountTarget.value = this.product.discount || ""
    }

    // The rate was set programmatically, so nothing observed it. Announce it now
    // that the product's own category has been applied: financial--line fills the
    // field from the rate only when the product left it empty.
    this.vatTarget.dispatchEvent(new Event("change"))
  }

  _replaceInput() {
    this.containerTarget.innerHTML = `
      <a data-toggle="modal"
         data-target="#remote-modal"
         data-route="/products/${this.product.id}"
         data-action="click->modal#show" href=""
      >
        <input type="text" id="" value="${this.product.name}"
          class="form-control pointer"
          disabled
        >
      </a>
    `
  }

  _readDataElement() {
    const dataElement = document.getElementById("asset-print")
    if (!dataElement) return

    return JSON.parse(dataElement.innerText)
  }
}
